import type { ErrorBoundaryContextProps } from 'components/common-form/builder/form/errorBoundary';
import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import type { FC, PropsWithChildren } from 'react';
import type { FallbackProps } from 'react-error-boundary';

import { useIsNotInProduction } from '../../../../../contexts/environment/useIsProduction';
import { useSPIntl } from '../../../../../hooks/useIntl';
import { IconActionButton } from './IconActionCellRenderer';

export const ErrorBoundaryCellFallback: FC<FallbackProps & ErrorBoundaryContextProps> = ({ error }) => {
  const isNotInProduction = useIsNotInProduction();
  const { formatMessage } = useSPIntl();

  const title = isNotInProduction ? (error as Error)?.message : formatMessage({ id: 'generic.error.message' });

  return <IconActionButton icon="error" location="right" title={title} className="btn-flat-danger m-auto" />;
};

export const WithGenericErrorCellBoundary = (
  Component: FC<PropsWithChildren<any>>,
  gridContext?: Record<string, string | undefined>,
): FC<PropsWithChildren<any>> => {
  return props => {
    const colDef = props.colDef;
    const nodeId = props.node?.id;

    const colContext: Record<string, string> = {
      columnType: colDef?.type,
      field: colDef?.field ?? '',
      id: nodeId,
    };

    const context = { ...colContext, ...gridContext };
    return (
      <GenericErrorBoundary context={context} Fallback={ErrorBoundaryCellFallback}>
        <Component {...props} />
      </GenericErrorBoundary>
    );
  };
};
